import { swiperFunctions } from './swiper'
import { tabsFunctions } from './tabs'
import { overlaysFunctions } from './overlay'
import { productCardFunctions } from './product-card'
import { copyPreviewImgToThumbsSlides } from '../pages/product-detail'
import { filterFunctions } from './filter'
import { subscribeFunctions } from './subscribe'

export const blockFunctions = () => {
  copyPreviewImgToThumbsSlides()
  productCardFunctions()
  tabsFunctions()
  overlaysFunctions()
  filterFunctions()
  swiperFunctions()
  subscribeFunctions()
}
